/* eslint-env browser */

const DomHelper = require('../../../../client/clientjs/dom-helper')
const ModalsHelper = require('../../../../client/clientjs/utils/modals')

function getScrollPercent() {
  const h = document.documentElement
  const b = document.body
  const st = 'scrollTop'
  const sh = 'scrollHeight'
  return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100
}

module.exports = () => {
  const started = Date.now()

  if (window.location.pathname.startsWith('/gear/products/')) {
    return
  }

  const login = DomHelper.query('#incentive-login')
  if (login) {
    const deleteLogin = DomHelper.query(login, '.delete')
    if (deleteLogin) {
      DomHelper.on(deleteLogin, 'click', e => {
        e.preventDefault()
        e.cancelBubble = true
        if (e.stopPropagation) e.stopPropagation()
        DomHelper.addClass(login, 'fadeOutDown')
        return false
      })
    }
    let loginShowed = false
    DomHelper.on(window, 'scroll', () => {
      const scrollPercent = getScrollPercent()
      const shouldShow = !loginShowed && (scrollPercent > 25 || (scrollPercent > 5 && Date.now() - started > 3000)) // 3seconds delay
      if (shouldShow) {
        loginShowed = true
        DomHelper.removeClass(login, 'is-hidden')
        DomHelper.addClass(login, 'fadeInUp')
        DomHelper.on(login, 'click', e => {
          e.preventDefault()
          ModalsHelper.open('#modal-signup')
          DomHelper.addClass(login, 'fadeOutDown')
        })
      }
    })
  }

  const mobileAppIncentive = DomHelper.query('#mobile-bottom-app-incentive')
  if (mobileAppIncentive) {
    const deleteIncentive = DomHelper.query(mobileAppIncentive, '.delete')
    if (deleteIncentive) {
      DomHelper.on(deleteIncentive, 'click', e => {
        e.preventDefault()
        e.cancelBubble = true
        if (e.stopPropagation) e.stopPropagation()
        DomHelper.addClass(mobileAppIncentive, 'slideOutDown')
        return false
      })
    }
    DomHelper.on(window, 'scroll', () => {
      const scrollPercent = getScrollPercent()
      const shouldShow = scrollPercent > 25 || (scrollPercent > 1 && Date.now() - started > 3000) // 3seconds delay
      if (shouldShow) {
        DomHelper.removeClass(mobileAppIncentive, 'is-hidden')
        DomHelper.addClass(mobileAppIncentive, 'slideInUp')
      }
    })
  }
}
